import React from 'react';
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/posts/posts.css";

import backArrowIcon from "../../images/back_arrow_icon_2.png";
import fVideo from "../../videos/3d_model_display_video.mp4";
import playIcon from "../../images/posts/play_icon.png";

const Posts = () => {
    const videoRef = useRef(null);
    const navigate = useNavigate();
    const [getIsPlay, setIsPlay] = useState(true);
    const [setCurrentVideo] = useState(fVideo);

    const goBack = () => {
        navigate(-1);
    };

    const onPlayOrPause = () => {
        // const video = document.querySelector('.posts_screen_back_column_video');
        const video = videoRef.current;
        if (video.paused) {
            video.play();
            setIsPlay(true);
        } else {
            video.pause();
            setIsPlay(false);
        }
    }

    const touchStartY = useRef(0);
    const touchEndY = useRef(0);

    const handleTouchStart = (e) => {
        touchStartY.current = e.changedTouches[0].clientY;
    };

    const handleTouchMove = (e) => {
        touchEndY.current = e.changedTouches[0].clientY;
    };

    const handleTouchEnd = () => {
        if (touchStartY.current - touchEndY.current > 100) {
            // Swipe up detected (swiped more than 100px upwards)
            console.log("Swipe Up Detected!");
            // Change the video source to the next video
            setCurrentVideo(fVideo); // Change to another video
        }
    };

    const onVolumeUp = () => {
        const videoElement = document.querySelector('.posts_screen_back_column_video');
        // const videoElement = videoRef.current;
        if (videoElement) {
            videoElement.volume = 1; 
        }
    }

    return(
        <div className="posts_screen">
            <div className="posts_screen_head_container_row">
                <div className="posts_screen_head_row_b">
                    <img alt='back' onClick={goBack} className="posts_screen_back" src={backArrowIcon} /> 
                    <p className="posts_screen_header">Posts</p>
                </div>
                {/* <img onClick={goBack} className="posts_screen_back" src={backArrowIcon} /> 
                <p className="posts_screen_header">Posts</p> */}
                <p className="posts_screen_back_saved">Saved</p>
                {/* <p onClick={goBack} className="home_view_item_back">back</p> */}
            </div> 
            <div className="posts_screen_divider"></div>
            <div className="posts_screen_block">
                <div className="posts_screen_back_column">
                    <div className="posts_screen_back_column_container" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
                        <video ref={videoRef} className="posts_screen_back_column_video" muted autoPlay loop onClick={onPlayOrPause} onCanPlay={onVolumeUp}>
                            <source src={fVideo} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        <img alt='play' src={playIcon} onClick={onPlayOrPause} className={`posts_screen_back_column_play ${!getIsPlay ? "show" : ""}`} />

                        {/* <iframe
                            className="posts_screen_back_column_video"
                            src={fVideo}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="YouTube Video"
                        ></iframe> */}
                    </div>
                </div>
            </div>           
        </div>
    );
};

export default Posts;